const PublicStyles = () => ({

});
export default PublicStyles;